import { useState } from 'react';
import { Grid, Box, Stack, Title, Text, Button, em, Group, Image } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';
import { useSelector } from 'react-redux';
import { selectPricingContent } from '../../../redux/selectors/publicSelector';
import DetailsModal from '../details/details.modal';
import colors from '../../../utils/styles';

const PricingSection = ({ scrollToCalendar }: { scrollToCalendar: () => void }) => {
    const [modalOpened, setModalOpened] = useState(false);
    const isMobile = useMediaQuery(`(max-width: ${em(750)})`);
    const isTablet = useMediaQuery(`(max-width: ${em(990)})`);

    const pricingContent = useSelector(selectPricingContent);

    return (
        <>
            <Grid py="xl" gutter={0}>
                <Grid.Col span={{ base: 12, md: 6 }}>
                    <Box p={isMobile ? 'md' : 'xl'} style={{ border: "5px solid #fed537", borderRadius: '10px', height: '100%', margin: 5 }}>
                        <Stack gap="md" h="100%">
                            <Title size={32} style={{ color: colors.appYellow, fontSize: isMobile ? 'clamp(20px, 24px, 32px)' : '32px' }}>{pricingContent.data[0].title}</Title>
                            <Text style={{ color: 'white', fontSize: isMobile ? 'clamp(0.2rem, 1rem, 1.25rem)' : '1.25rem', flex: 1 }}>
                                {pricingContent.data[0].description}
                            </Text>
                        </Stack>
                    </Box>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }} pt={isTablet ? 'md' : 0}>
                    <Box p={isMobile ? 'md' : 'xl'} style={{ border: "5px solid #fed537", borderRadius: '10px', height: '100%', margin: 5 }}>
                        <Stack h="100%" gap="md">
                            <Title size={32} style={{ color: colors.appYellow, fontSize: isMobile ? 'clamp(20px, 24px, 32px)' : '32px' }}>{pricingContent.data[1].title}</Title>
                            <Text style={{ color: 'white', fontSize: isMobile ? 'clamp(0.2rem, 1rem, 1.25rem)' : '1.25rem', flex: 1 }}>
                                {pricingContent.data[1].description}
                                <br />
                                {pricingContent.data[1].options?.[0]}{' '}
                                <span
                                    onClick={() => setModalOpened(true)}
                                    style={{
                                        textDecoration: 'underline',
                                        color: colors.appPink,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {pricingContent.data[1].options?.[1]}
                                </span>.
                            </Text>
                        </Stack>
                    </Box>
                </Grid.Col>
            </Grid>
            {!isTablet && <Group justify="center" mt="lg" mb="lg">
                <Button
                    size="lg"
                    radius="xl"
                    onClick={scrollToCalendar}
                    style={{ backgroundColor: colors.appPink, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)' }}
                >
                    BOOK NOW
                </Button>
            </Group>}
            <DetailsModal
                opened={modalOpened}
                onClose={() => setModalOpened(false)}
                yOffset='10vh'
                title={pricingContent.goldenTicketMoreInfo.title}
                titleColor={colors.appYellow}
                description={(
                    <Stack gap="md">
                        <Text fw={700} style={{ textAlign: 'center' }}>{pricingContent.goldenTicketMoreInfo.description}</Text>

                        {pricingContent.goldenTicketMoreInfo.data?.map((item, index) => (
                            <Stack key={index} gap="xs">
                                <Text fw={700}>{item.title}</Text>
                                <Text>{item.description}</Text>
                            </Stack>
                        ))}
                        <Image src="/assets/images/golden_ticket.jpg" />
                    </Stack>
                )}
            />
        </>
    )
}

export default PricingSection;  